.filter {
  position: relative;
  display: flex;
  min-width: 100px;
  margin: 4px;
}

.filter-icon {
  position: absolute;
  top: 8px;
  left: 8px;
  width: 16px;
  cursor: default;
}

.filter-input {
  border: 1px solid #9e9e9e;
  border-radius: 5px;
  height: 28px;
  width: 100%;
  padding: 2px 23px 2px 30px;
  outline: 0;
}
